/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */
import axios from "axios"
import { DOMAIN_ADMIN_ROLE, SYSTEM_ADMIN_ROLE } from "@/common/constants"

const state = {
  user: {
    userName: null,
    roles: [],
    clientName: null,
    firstName: null,
    lastName: null,
    domainName: null,
    privateHelpPage: null
  }
}

const getters = {
  username: state => state.user.userName,
  roles: state => state.user.roles,
  hasRole: (state, getters) => role => getters.roles.includes(role),
  hasAccess: (state, getters) => roles => {
    if (!roles || roles.length === 0 || getters.isSystemAdmin) return true
    return roles.some(role => getters.hasRole(role))
  },
  isLoggedIn: state => !!state.user.userName,
  isSystemAdmin: (state, getters) => getters.hasRole(SYSTEM_ADMIN_ROLE),
  isTeamOwner: (state, getters) => getters.hasRole(DOMAIN_ADMIN_ROLE),
  fullName: state => `${state.user.firstName} ${state.user.lastName}`,
  clientName: state => state.user.clientName,
  isSingleTeam: state => state.user.teamType === "SINGLE",
  isMultiTeam: state => state.user.teamType === "MULTI_TEAM",
  privateHelpPage: state => state.user.privateHelpPage
}

const mutations = {
  setUser(state, user) {
    if (user) {
      console.log("Set current user", user)
      state.user = user
    }
  }
}

const actions = {
  getECUserInfo({ commit }) {
    return axios
      .get("/services/user/info")
      .then(response => commit("setUser", response.data))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ecuserinfo.js